<div class="create-snapshot-modal-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">Create New Snapshot</h2>
    <button 
      mat-icon-button 
      class="close-button" 
      (click)="onCancel()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <div class="form-section">
      <label class="input-label">Enter snapshot name</label>
      <div class="input-container">
        <input 
          #nameInput
          type="text"
          class="snapshot-input"
          placeholder=""
          [(ngModel)]="snapshotName"
          (input)="onNameInput()"
          (keydown.enter)="onCreateSnapshot()"
          maxlength="100"
          [disabled]="isCreating()"
          required
        >
      </div>
    </div>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button 
      class="cancel-button"
      (click)="onCancel()"
      [disabled]="isCreating()"
    >
      Cancel
    </button>
    
    <button 
      class="create-button"
      [disabled]="!isValid || isCreating()"
      (click)="onCreateSnapshot()"
    >
      {{ isCreating() ? 'Creating...' : 'Create' }}
    </button>
  </div>
</div> 